module.exports = __webpack_public_path__ + "img/glamping_5.4c331fda.jpg";